import React from 'react'

const TotalVehiclesSkeleton = () => {
    return <div className='skeleton skeleton-text' style={{ width: '10%' }}></div>
}

export default TotalVehiclesSkeleton
